module.exports = __webpack_public_path__ + "static/media/aboutUs-banner.9bffd997.jpg";